import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t/* clears the 'X' from Internet Explorer */\n\tinput[type='search']::-ms-clear {\n\t\tdisplay: none;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\tinput[type='search']::-ms-reveal {\n\t\tdisplay: none;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t/* clears the 'X' from Chrome */\n\tinput[type='search'] ::-webkit-search-decoration,\n\tinput[type='search']::-webkit-search-cancel-button,\n\tinput[type='search']::-webkit-search-results-button,\n\tinput[type='search']::-webkit-search-results-decoration {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css } from '@wp-g2/styles';
export var SearchInput = css(_templateObject());